import { UseQueryResult, useQuery } from 'react-query';

import { GetReportDataForSiteQueryParams } from '@pimm/services/lib/store-inspections/types';
import { GetReportDataForSite } from '@pimm/services/lib/store-inspections/services';

export const useGetReportDataForSite = (
  _query?: Partial<GetReportDataForSiteQueryParams>,
  _queryKey?: string,
): UseQueryResult<Awaited<ReturnType<typeof GetReportDataForSite>>> => {
  const reportData = useQuery({
    enabled: !!_query?.siteId && !!_query.date && !!_query.storeReportId,
    queryKey: [_queryKey ?? 'GetReportDataForSite', _query],
    queryFn: async () => {
      const result = await GetReportDataForSite(_query as GetReportDataForSiteQueryParams);
      return result;
    },
  });

  return reportData;
};
